import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";

interface DeleteTeamConfirmationPromptProps {
  showDeleteConfirmation: boolean;
  setShowDeleteConfirmation: (value: boolean) => void;
  isDeleting: boolean;
  handleDelete: () => void;
  selectedTeam: { id: string; name: string };
  t: (key: string, options?: any) => string;
}

const DeleteTeamConfirmationPrompt = ({
  showDeleteConfirmation,
  setShowDeleteConfirmation,
  isDeleting,
  handleDelete,
  selectedTeam,
  t,
}: DeleteTeamConfirmationPromptProps) => (
  <FixaModal
    handleCloseBtn={() => setShowDeleteConfirmation(false)}
    visible={showDeleteConfirmation}
  >
    <FixaPrompt
      aria-label={t("areYouSureYouWantToDeleteString", {
        item: selectedTeam.name,
      })}
      footer={
        <FixaModalFooter>
          <FixaButton
            type="secondary"
            disabled={isDeleting}
            onClick={() => setShowDeleteConfirmation(false)}
          >
            {t("cancelString")}
          </FixaButton>
          <FixaButton
            type="danger"
            disabled={isDeleting}
            onClick={handleDelete}
          >
            {t("deleteString")}
          </FixaButton>
        </FixaModalFooter>
      }
      header={<FixaModalHeader title={t("deleteTeamString")} />}
      title=""
      titleId=""
    >
      <p>
        {t("areYouSureYouWantToDeleteString")} <b>{selectedTeam.name}?</b>
      </p>
    </FixaPrompt>
  </FixaModal>
);

export default DeleteTeamConfirmationPrompt;
